import styled from 'styled-components'
import { Button } from '@sketch/components'

export const StyledButton = styled(Button)`
  min-width: 120px;
`
